import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

export default function RoleEntry(
    {
        children,
        onClick = () => {},
        selected = false,
    }
) {
    let buttonClass = '';
    if (selected) {
        buttonClass = 'bg-[linear-gradient(135deg,var(--tw-gradient-stops))] from-violet-500/[0.12] dark:from-violet-500/[0.24] to-violet-500/[0.04]';
    }

    return <li className="mr-0.5 md:mr-0 md:mb-0.5">
        <a
            href={'#'}
            className={`flex items-center px-2.5 py-2 rounded-lg whitespace-nowrap ${buttonClass}`}
            onClick={onClick}
        >
            <span
                className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-700 dark:hover:text-gray-200"
            >
                {children}
            </span>
        </a>
    </li>;

}